// src/ga4.ts
import { sendGAEvent } from "@next/third-parties/google";
var dispatchGA4Event = (event) => {
  switch (event.name) {
    case "shows_browsed":
      sendGAEvent("event", "view_item_list", {
        item_list_id: "shows",
        item_list_name: "Shows"
      });
      break;
    case "show_viewed":
      sendGAEvent("event", "view_item", {
        items: [
          {
            item_id: event.data.showSlug,
            item_name: event.data.showName,
            item_category: "shows"
          }
        ]
      });
      break;
    case "seat_map_viewed":
      sendGAEvent("event", "view_item", {
        items: [
          {
            item_id: event.data.performanceId,
            item_name: event.data.showName,
            item_category: "tickets"
          }
        ]
      });
      break;
    case "seat_selected":
      sendGAEvent("event", "add_to_cart", {
        currency: "USD",
        value: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0,
        items: [
          {
            item_id: event.data.seatId,
            item_name: event.data.legendDescription,
            item_category: "tickets",
            item_variant: `Row ${event.data.row} Seat ${event.data.seatNumber}`,
            price: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0
          }
        ]
      });
      break;
    case "seat_removed":
      sendGAEvent("event", "remove_from_cart", {
        currency: "USD",
        value: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0,
        items: [
          {
            item_id: event.data.seatId,
            item_name: event.data.legendDescription,
            item_category: "tickets",
            item_variant: `Row ${event.data.row} Seat ${event.data.seatNumber}`,
            price: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0
          }
        ]
      });
      break;
    case "checkout_started":
      sendGAEvent("event", "begin_checkout", {
        currency: event.data.currency ?? "USD",
        value: Number.parseFloat(event.data.totalAmount),
        num_items: event.data.itemCount
      });
      break;
    case "purchase_completed":
      sendGAEvent("event", "purchase", {
        transaction_id: event.data.orderId,
        currency: event.data.currency,
        value: Number.parseFloat(event.data.totalAmount),
        num_items: event.data.itemCount
      });
      break;
    case "button_interaction":
      sendGAEvent("event", "buttonInteraction", {
        value: event.data.value
      });
      break;
    case "link_interaction":
      sendGAEvent("event", "linkInteraction", {
        value: event.data.value
      });
      break;
  }
};

// src/meta-pixel.ts
var dispatchMetaPixelEvent = (event) => {
  if (typeof window === "undefined" || !window.fbq) return;
  switch (event.name) {
    case "shows_browsed":
      window.fbq("track", "ViewContent", {
        content_type: "product_group",
        content_category: "shows"
      });
      break;
    case "show_viewed":
      window.fbq("track", "ViewContent", {
        content_ids: [event.data.showSlug],
        content_name: event.data.showName,
        content_type: "product",
        content_category: "shows"
      });
      break;
    case "seat_map_viewed":
      window.fbq("track", "ViewContent", {
        content_ids: [event.data.performanceId],
        content_name: event.data.showName,
        content_type: "product",
        content_category: "tickets"
      });
      break;
    case "seat_selected":
      window.fbq("track", "AddToCart", {
        content_ids: [event.data.seatId],
        content_name: event.data.legendDescription,
        content_type: "product",
        value: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0,
        currency: "USD"
      });
      break;
    case "seat_removed":
      window.fbq("trackCustom", "RemoveFromCart", {
        content_ids: [event.data.seatId],
        value: event.data.price !== void 0 ? Number.parseFloat(event.data.price) : void 0,
        currency: "USD"
      });
      break;
    case "checkout_started":
      window.fbq("track", "InitiateCheckout", {
        value: Number.parseFloat(event.data.totalAmount),
        currency: event.data.currency ?? "USD",
        num_items: event.data.itemCount,
        content_type: "product"
      });
      break;
    case "purchase_completed":
      window.fbq("track", "Purchase", {
        value: Number.parseFloat(event.data.totalAmount),
        currency: event.data.currency,
        num_items: event.data.itemCount,
        content_type: "product"
      });
      break;
    // No Meta Pixel equivalent for generic UI interactions
    case "button_interaction":
    case "link_interaction":
      break;
  }
};

// src/index.ts
var trackEvent = (event) => {
  dispatchMetaPixelEvent(event);
  dispatchGA4Event(event);
};
export {
  trackEvent
};
